import { useModal } from 'vue-final-modal';
import uuidv4 from '@/helpers/uuid';

const ModalPlugin = {
  // eslint-disable-next-line
  install: function (app, options) {
    const { appInstance } = options;

    const modalContainer = document.createElement('div');
    modalContainer.id = 'modal-wrapper';
    document.getElementsByTagName('body')[0].appendChild(modalContainer);

    if (!appInstance) {
      console.error('appInstance parameter must be required!'); // eslint-disable-line
      return;
    }
    // eslint-disable-next-line func-names
    app.config.globalProperties.$showModal = function (Component, props, listeners = {}) {
      function capitalizeFirstLetter(string) {
        return string.charAt(0).toUpperCase() + string.slice(1);
      }

      const events = {};
      Object.keys(listeners).forEach((e) => {
        events[`on${capitalizeFirstLetter(e)}`] = listeners[e];
      });

      const modalId = uuidv4();
      const modal = useModal({
        component: Component,
        attrs: {
          ...props,
          ...events,
          onClose: () => {
            // Destroy immediately rather than awaiting close()'s transition: a
            // programmatic modal whose component isn't a <VueFinalModal> (e.g.
            // FullScreenModal) never resolves close(), which previously required
            // a second click to dismiss. destroy() unmounts it on the first click.
            modal.close();
            modal?.destroy();
          },
          onCancel: () => {
            modal.close();
            modal?.destroy();
          },
          modalId,
        },
      });
      modal.open();
      return {
        close: modal.destroy,
      };
    };
  },
};

export default ModalPlugin;
